<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				个人汇总代开
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platjxticket:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platjxticket:export')" type="primary" @click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>
					<el-form-item><el-button type="info" @click="getDataList()">刷新</el-button></el-form-item>
					<el-form-item><el-button v-if="$hasPermission('plat:platjxticket:delete')" type="danger" @click="deleteHandle()">删除</el-button></el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<div class="mod-plat__platticketrecord}">
			<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
				<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
				<el-table-column label="序号" type="index" width="50" align="center">
					<template slot-scope="scope">
						<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<!--<el-table-column prop="id" label="" header-align="center" align="center"></el-table-column>-->
				<el-table-column prop="code" label="发票代码" header-align="center" align="center"></el-table-column>
				<el-table-column prop="number" label="发票号码" header-align="center" align="center"></el-table-column>
				<el-table-column prop="amount" label="发票金额" header-align="center" align="center"></el-table-column>
				<el-table-column prop="tax" label="发票税额" header-align="center" align="center"></el-table-column>
				<el-table-column prop="total" label="价税合计" header-align="center" align="center"></el-table-column>
				<el-table-column prop="billingDate" label="开票日期" header-align="center" align="center"></el-table-column>
				<el-table-column prop="remark" label="备注" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
				  <template slot-scope="scope">
				    <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">详情</el-button>
				  </template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				:current-page="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="limit"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
				@size-change="pageSizeChangeHandle"
				@current-change="pageCurrentChangeHandle"
			></el-pagination>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		</div>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './platjxticket-add-or-update'
import Cookies from 'js-cookie'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      options: [
        {
          value: '0',
          label: '未开票'
        },
        {
          value: '1',
          label: '已开票'
        }
      ],
      value: '',
      role: Cookies.get('admin_role'),
      mixinViewModuleOptions: {
        getDataListURL: '/sys/income-invoice/page',
        getDataListIsPage: true,
        deleteURL: '/sys/income-invoice/delete',
        deleteIsBatch: true,
        exportURL: '/sys/income-invoice/export'
      },
      dataForm: {
        ids: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {

    yulan (url) {
      window.open(url, url)
    }
  }
}
</script>
